import React, { useMemo, useState } from 'react';
import styles from './Notification.module.css';
import Button from 'antd/lib/button/button';
import { NotificationActions } from '../../../store/actions/notificationActions';
import { NotificationProps } from '../../../store/state/NotificationState';
import Modal from 'antd/lib/modal';
import CloseIconButton from '../../../components/CloseIconButton/CloseIconButton';
import { ThemeProvider } from '../../../layout/ThemeProvider';
import { ThemeConfigKeys } from '../../../utils/Constants';


export enum NotificationType {
  SUCCESS = "success",
  WARNING = "warning",
  CLIENT_ERROR = "client_error",
  ERROR = "error",
  INFO = "info",
  NOTIFICATION = "notification",
}

const Notification: React.FC<NotificationProps> = (props: NotificationProps) => {

  const [loaded, setLoaded] = useState(false);
  const [hidden, setHidden] = useState(false);

  const unmountNotification = () => {
    setHidden(true);
    NotificationActions.removeNotification(props);
  };

  useMemo(() => {
    if (!loaded) {
      setTimeout(() => {
        setLoaded(true);
      }, 0);

      if (props.closeTimeout != null) {
        setTimeout(() => {
          unmountNotification();
        }, props.closeTimeout);
      }
    }
  }, []);

  if (!loaded) {
    return null;
  }

  const buttonClickHandler = async (action: () => Promise<any>) => {
    return await action().then(() => unmountNotification());
  };

  const onClose = async () => {
    if (props?.closePopupHandler) {
      return await props?.closePopupHandler().then(() => unmountNotification());
    }
    unmountNotification()
  }

  return (
      <ThemeProvider themeKey={ThemeConfigKeys.DnataBlue}>
        <Modal
          open={!hidden}
          className={styles.notificationModal}
          aria-label={props.title || 'Notification'}
          centered
          destroyOnClose
          closable={false}
          maskClosable={false}
          onCancel={onClose}
          title={props.hideCloseButton ? null : <CloseIconButton onClick={onClose} />}
          footer={props.buttons?.length ? <div className={styles.buttonContainer}>{props.buttons.map((button, index) => (
            <Button key={`b_${props.id}_${index}`} type={button.type || 'primary'}
              onClick={() => button.action ? buttonClickHandler(button.action) : onClose()}>
              {button.caption}
            </Button>
          ))}</div> : null}
        >
          {props.message != null ? <div className={styles.message} dangerouslySetInnerHTML={{ __html: props.message }} /> : props.children}
          {props.details != null && <div className={styles.details}>{props.details}</div>}
        </Modal>
      </ThemeProvider>
  );
}

export default Notification;